<template>
  <el-input v-model="toSearch" :placeholder="$t('post.sidebar.toSearch')"></el-input>
</template>

<script>
  export default {
    name: "SearchPost",
    props: {
      search: {
        type: String
      },
    },
    computed: {
      toSearch: {
        get() {
          return this.search;
        },
        set(value) {
          this.$emit('setSearch', value);
        },
      },
    }
  };
</script>
